import { render, staticRenderFns } from "./select_region.vue?vue&type=template&id=2be892b9&scoped=true&"
import script from "./select_region.vue?vue&type=script&lang=js&"
export * from "./select_region.vue?vue&type=script&lang=js&"
import style0 from "./select_region.vue?vue&type=style&index=0&id=2be892b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be892b9",
  null
  
)

export default component.exports